// Task Board do Tibia (Winter Update 2025): Bounty Talisman e Weekly Tasks.
// Bounty Talisman (oficial): bônus contra a criatura da tarefa de caça atual; melhorado com pontos de tarefa
// (5 no 1º nível, +12 por nível). Aqui o talismã não ocupa espaço: as melhorias ficam no personagem.
// Weekly Tasks: novas toda segunda (meia-noite de Brasília); dificuldade pelo level; XP 1,995 × level² com teto;
// pontos (HTP) com o multiplicador semanal oficial. Tarefas de abate e de entrega (itens de criatura levados na mochila). Quantidades propostas.

export type TalismanKey = 'leech' | 'dmg' | 'loot' | 'bestiary';
export const TALISMAN: Record<TalismanKey, { name: string; step: number; cap: number; after: number; desc: string }> = {
  leech: { name: 'Roubo de vida', step: 0.5, cap: 10, after: 0.25, desc: 'roubo de vida contra a criatura da tarefa' },
  dmg: { name: 'Dano', step: 0.5, cap: 10, after: 0.25, desc: 'dano contra a criatura da tarefa' },
  loot: { name: 'Loot', step: 0.5, cap: 10, after: 0.25, desc: 'chance de loot da criatura da tarefa (não soma com o charm Gut)' },
  bestiary: { name: 'Bestiário', step: 1, cap: 20, after: 0.5, desc: 'chance de o abate contar 2x no bestiário' },
};
export const TALISMAN_MAX_LEVEL = 60;
/** valor (%) de um bônus no nível */
export function talismanValue(k: TalismanKey, lv: number): number {
  const t = TALISMAN[k];
  const capLv = t.cap / t.step;
  return Math.round((lv <= capLv ? lv * t.step : t.cap + (lv - capLv) * t.after) * 100) / 100;
}
/** pontos de tarefa para subir do nível lv para lv+1 */
export const talismanCost = (lv: number) => 5 + 12 * lv;

export type WeeklyDiff = 0 | 1 | 2 | 3;
export const WEEKLY_DIFF_NAMES = ['Beginner', 'Adept', 'Expert', 'Master'] as const;
export const weeklyDiff = (level: number): WeeklyDiff => (level >= 400 ? 3 : level >= 150 ? 2 : level >= 30 ? 1 : 0);
export const WEEKLY_KILLS = [100, 200, 300, 400] as const;
export const WEEKLY_HTP = [25, 50, 100, 110] as const;
export const WEEKLY_XP_CAP = [200_000, 800_000, 3_000_000, Infinity] as const;
export const weeklyXp = (level: number, d: WeeklyDiff) => Math.min(WEEKLY_XP_CAP[d], Math.round(1.995 * level * level));
/** multiplicador semanal oficial pelo número de tarefas concluídas antes desta */
export const weeklyMult = (done: number) => (done >= 16 ? 8 : done >= 12 ? 5 : done >= 8 ? 3 : done >= 4 ? 2 : 1);
/** tarefas por semana: 6 para todos (proposta: o Tibia tem 6 de abate + 6 de entrega, ou 9+9 com a expansão) */
export const WEEKLY_COUNT = 6;
export const WEEKLY_COUNT_VIP = 9;

export interface WeeklyTask { monster: string; need: number; kills: number }
/** tarefa semanal de entrega: levar itens de criatura (oficial: 75 HTP × multiplicador) */
export interface WeeklyDelivery { itemId: number; name: string; need: number; done: boolean }
export const WEEKLY_DELIVERY_HTP = 75;
export const WEEKLY_DELIVERIES = 3;
export interface TaskBoardState {
  talisman: Partial<Record<TalismanKey, number>>;
  week?: string; diff?: WeeklyDiff; weekly: WeeklyTask[]; deliveries?: WeeklyDelivery[]; weeklyDone: number; htp: number; htpTotal: number;
}
export const emptyTaskBoard = (): TaskBoardState => ({ talisman: {}, weekly: [], weeklyDone: 0, htp: 0, htpTotal: 0 });

/** semana atual (segunda-feira, horário de Brasília) */
export function weekKey(now = Date.now()): string {
  const br = new Date(now - 3 * 3600_000);
  const wd = (br.getUTCDay() + 6) % 7;   // 0 = segunda
  const mon = new Date(Date.UTC(br.getUTCFullYear(), br.getUTCMonth(), br.getUTCDate() - wd));
  return mon.toISOString().slice(0, 10);
}

export interface HtpShopItem { id: string; name: string; cost: number; desc: string }
export const HTP_SHOP: HtpShopItem[] = [
  { id: 'card', name: '2 Prey Cards', cost: 100, desc: 'Para trocar bônus ou escolher a criatura do prey.' },
  { id: 'boost', name: 'Boost de XP (1 hora)', cost: 300, desc: '+50% de experiência por 60 minutos.' },
  { id: 'frag', name: '3 fragmentos de pedra de proteção', cost: 400, desc: 'Para o refine.' },
  { id: 'best2x', name: 'Bestiary Betterment (2 horas)', cost: 600, desc: 'Abates contam em dobro no bestiário por 2 horas.' },
  { id: 'gem', name: 'Lesser Gem', cost: 1500, desc: 'Uma gema para a Wheel of Destiny (domínio aleatório).' },
  { id: 'rgem', name: 'Regular Gem', cost: 5000, desc: 'Uma gema maior para a Wheel of Destiny (domínio aleatório).' },
];
